import styled from 'styled-components';

import Contact from './Contact';
import CompanyInfo from './CompanyInfo';
import SocialIcons from './SocialIcons';
import { LIGHT_GREY_COLOR, TABLET_SIZE } from '../../constants';

const StyledFooter = styled.div`
  padding: 50px 54px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  background-color: ${LIGHT_GREY_COLOR};
  flex-shrink: 0;

  @media (max-width: ${TABLET_SIZE}) {
    padding: 50px 0;
    justify-items: center;
    grid-template-columns: 1fr;
  }
`;

export default () => (
  <StyledFooter>
    <Contact />
    <SocialIcons />
    <CompanyInfo />
  </StyledFooter>
);



// WEBPACK FOOTER //
// components/Footer/index.js